import { Component, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { GojsSchematicComponent } from '../../../../gojs-schematic/gojs-schematic.component';

@Component({
  selector: 'lib-nec-substation-details-schematic',
  standalone: false,
  templateUrl: './nec-substation-details-schematic.component.html',
  styleUrl: './nec-substation-details-schematic.component.scss'
})
export class NecSubstationDetailsSchematicComponent {
  @Input() substationId: number | null = null;
  @Input() substationName: string | null = null;
  @Output() closeSchematic = new EventEmitter<void>();

  @ViewChild(GojsSchematicComponent) private gojsSchematic?: GojsSchematicComponent;

  onClose() {
    this.gojsSchematic?.flushPendingSave();
    this.closeSchematic.emit();
  }

  // The overlay is fixed over the page, but the wheel still scroll-chains through the DOM to the page under it.
  // Only let it through when something inside the schematic can still scroll that way; GoJS handles its own zoom.
  onOverlayWheel(event: WheelEvent) {
    const overlay = event.currentTarget as HTMLElement;
    let el = event.target as HTMLElement | null;
    while (el && el !== overlay) {
      const canScroll = /(auto|scroll)/.test(getComputedStyle(el).overflowY) && el.scrollHeight > el.clientHeight;
      if (canScroll && (event.deltaY < 0 ? el.scrollTop > 0 : el.scrollTop + el.clientHeight < el.scrollHeight)) return;
      el = el.parentElement;
    }
    event.preventDefault();
  }

  onOverlayClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      // Routes through the same gate as the schematic's own X button, so an
      // outside click while mid-edit prompts instead of silently discarding.
      if (this.gojsSchematic) this.gojsSchematic.onCloseSchematic();
      else this.onClose();
    }
  }
}